import { useBackendApi } from './backendApi';
import { useEventsPublisher, useEventsSubscriber } from 'event-bus';
import { ProjectType } from './Types';

export interface FubPipeline {
  id: number;
  name: string;
}

export interface FubPipelineMapEntry {
  projectType: ProjectType;
  fubPipeline: FubPipeline;
}

export interface UpdatePipelineMapEntryRequest {
  pipelineId: number | null;
}

export const FUB_PIPELINES_MAPPING_UPDATED = 'PIPELINES_UPDATED';

export function useFubPipelineMappingService() {
  const nekstApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  useEventsSubscriber('fubPipelineMappingService', {
    [FUB_PIPELINES_MAPPING_UPDATED]: () => {}
  }, []);

  const getAllPipelines = async (profileId: number): Promise<FubPipeline[]> => {
    return await nekstApi.get(`/integrations/profiles/${profileId}/fub/pipelines`) as FubPipeline[];
  };

  const getMap = async (profileId: number): Promise<Record<string, number | null>> => {
    return await nekstApi.get(`/integrations/profiles/${profileId}/fub/pipelinesmap`) as Record<string, number | null>;
  };

  const getPipelineMapEntry = async (profileId: number, projectType: ProjectType): Promise<FubPipelineMapEntry | null> => {
    return await nekstApi.get(`/integrations/profiles/${profileId}/fub/pipelinesmap/${projectType}`) as FubPipelineMapEntry | null;
  };

  const updateMapEntry = async (profileId: number, projectType: ProjectType, request: UpdatePipelineMapEntryRequest): Promise<void> => {
    await nekstApi.put(`/integrations/profiles/${profileId}/fub/pipelinesmap/${projectType}`, request);
    eventsPublisher.publish(FUB_PIPELINES_MAPPING_UPDATED, {});
  };

  return {
    getAllPipelines,
    getMap,
    getPipelineMapEntry,
    updateMapEntry,
  };
}
